import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import { OfferApi } from "../utils/api"

import { WelcomeComponent, GetStartedComponent, CheckStatusComponent, MaintenanceModeComponent } from "../components"
import MetaTags from "react-meta-tags"

export const Home = () => {
  const [inMaintenanceMode, setInMaintenanceMode] = useState(true)
  const [maintenanceText, setMaintenanceText] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [isErrorFetchingMaintenanceText, setIsErrorFetchingMaintenanceText] = useState(false)
  const [sprintRedirectActive, setSprintRedirectActive] = useState(true)

  useEffect(() => {
    const checkMaintenanceMode = async () => {
      setIsLoading(true)
      try {
        const result = await OfferApi.getClientAsset("MaintenanceFlag")
        const maintenanceText = await OfferApi.getClientAsset("MaintenanceText")

        if (result.notes.toLowerCase() === "true") {
          setMaintenanceText(maintenanceText.notes)
          setIsLoading(false)
          return
        }

        setInMaintenanceMode(false)
      } catch (error) {
        if (error.message === "Unable to retrieve client asset") {
          setIsErrorFetchingMaintenanceText(true)
        }
        setErrorMessage("Something went wrong. Please try again.")
      } finally {
        setIsLoading(false)
      }
    }

    const checkSprintIntegrationDate = async () => {
      const result = await OfferApi.getClientAsset("SPRINT_START_DATE")
      let toggle = new Date(result.notes) >= new Date()
      if (toggle) {
        setSprintRedirectActive(false)
      }
    }

    checkMaintenanceMode()
    checkSprintIntegrationDate()
  }, [setInMaintenanceMode])

  const ActiveContent = () => (
    <>
      <GetStartedComponent sprintRedirectActive={sprintRedirectActive} />
      <CheckStatusComponent sprintRedirectActive={sprintRedirectActive} />
    </>)

  return (
    <>
      <MetaTags>
        <link rel="canonical" href="https://www.t-mobile.com/offers/deals-hub" />
      </MetaTags>
      <WelcomeComponent />
      {isErrorFetchingMaintenanceText &&
        <div className="text-center container">
          <h1 className="magenta">Temporarily Unavailable</h1>
          <p>This site is currently under going scheduled maintenance. We&apos;ll be back soon.</p>
          <p> Thank you for your patience.</p>
        </div>}
      {isLoading && <div style={{ textAlign: "center" }}>Loading ...</div>}
      {errorMessage.length > 0 && !isLoading && !isErrorFetchingMaintenanceText && <div style={{ textAlign: "center" }}>{errorMessage}</div>}
      {inMaintenanceMode && !isLoading && <MaintenanceModeComponent maintenanceText={maintenanceText} />}
      {!inMaintenanceMode && !isLoading && !isErrorFetchingMaintenanceText && <ActiveContent />}
    </>
  )
}

Home.propTypes = {
  history: PropTypes.object
}
